const ID: string = process.env.GOOGLE_TAG_MANAGER_ID || '';
const tagManagerArgs = { gtmId: ID };
export default tagManagerArgs;
